var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "md:pl-10 w-full md:w-3/4 md:pr-10" }, [
    _c("h1", { staticClass: "mb-6" }, [_vm._v("Duplicate Event")]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { ref: "festival", attrs: { for: "festival" } }, [
        _vm._v("\n            Select Event Calendar "),
        _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-6" }, [
        _vm._v("Make a copy of "),
        _c("strong", [_vm._v(_vm._s(_vm.event.title))]),
        _vm._v(" in the festival you select below:"),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.festivalId,
              expression: "festivalId",
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
          ],
          ref: "festival",
          attrs: { id: "festival", name: "festival" },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.festivalId = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _c("option", { attrs: { disabled: "" }, domProps: { value: null } }, [
            _vm._v("Select an event calendar"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.currentFestivals, function (festival) {
            return _c(
              "option",
              { key: festival.id, domProps: { value: festival.id } },
              [
                _vm._v(
                  _vm._s(festival.title) + " " + _vm._s(festival.datesTitle)
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.errors.has("festival")
        ? _c("span", { staticClass: "error text-error-red text-lg" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.errors
                    .first("festival")
                    .replaceAll("festival", "event calendar")
                ) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-6" }, [
      _c(
        "button",
        {
          staticClass: "button mb-12",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.duplicateEvent.apply(null, arguments)
            },
          },
        },
        [_vm._v("Duplicate")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }